// resetScene.js

var ResetScene = pc.createScript('ResetScene');

ResetScene.attributes.add("sceneName", {type: "string", default: "", title: "Scene Name to Load"});

ResetScene.prototype.initialize = function(dt) {
   // this.app.mouse.on(pc.EVENT_MOUSEDOWN, this.onMouseDown, this);
   // this.app.xr.on('end', this.onXREnd, this);
    // Change scenes in 1 second
    //var self = this;
};

ResetScene.prototype.onXREnd = function(){
  this.loadScene(this.sceneName);
};


ResetScene.prototype.loadScene = function (sceneName) {
    // Get a reference to the scene's root object
    var oldHierarchy = this.app.root.findByName ('RootMain');
    
    // Get the path to the scene
    var scene = this.app.scenes.find(sceneName);
    
    // Load the scenes entity hierarchy
    this.app.scenes.loadSceneHierarchy(scene.url, function (err, parent) {
        if (!err) {
            oldHierarchy.destroy();
        } else {
            console.error(err);
        }
    });
};


// swap method called for script hot-reloading
// inherit your script state here
// ResetScene.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

